import { render, staticRenderFns } from "./reservationListItem.vue?vue&type=template&id=3987a212&"
import script from "./reservationListItem.vue?vue&type=script&lang=ts&"
export * from "./reservationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./reservationListItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports